import { Injectable }       from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  Observable,
  Subject
}                           from 'rxjs';

import { ApiService }     from '../../api/api.service';
import { ConfirmService } from '../confirm/confirm.service';

@Injectable()
export class CustomerMessagesService {
  title = this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.CUSTOMER_MESSAGES.CUSTOMER_MESSAGES');

  private readonly refreshCustomersSmsLogsSubject    = new Subject<void>();
  readonly refreshCustomerSmsLogs$: Observable<void> = this.refreshCustomersSmsLogsSubject.asObservable();

  constructor(
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private translateService: TranslateService,
  ) {}

  activateLookups () : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {
      name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.CUSTOMER_MESSAGES.CUSTOMER_MESSAGES')
    }))
    .then(() => this.apiService.get('/sms_global_account/activate_sms_global_account'));
  }

  deactivateLookups () : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.REMOVE_INTEGRATION', {
      name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.CUSTOMER_MESSAGES.CUSTOMER_MESSAGES')
    }))
    .then(() => this.apiService.get('/sms_global_account/disable_sms_global_account'));
  }

  getLatestMessagesLogs ( params : any ) : Promise<any> {
    return this.apiService.get('/sms_logs/get_recent_sms_log_customers', [ params.page_size, params.offset ]);
  }

  getCustomerSmsLogs (
    identifier : { customer_id?: string | null; mobile?: string | null },
    params     : { page_size: number; offset: number }
  ) : Promise<any> {

    const pageSize = params?.page_size ?? 20;
    const offset   = params?.offset ?? 0;

    const parts : string[] = [
      `page_size=${encodeURIComponent(String(pageSize))}`,
      `offset=${encodeURIComponent(String(offset))}`
    ];

    if (identifier?.customer_id) {
      parts.unshift(`customer_id=${encodeURIComponent(String(identifier.customer_id))}`);
    } else if (identifier?.mobile) {
      parts.unshift(`mobile=${encodeURIComponent(String(identifier.mobile))}`);
    }

    const url = `/sms_logs/get_customer_sms_logs?${parts.join('&')}`;
    return this.apiService.get(url);
  }

  refreshCustomerSmsLogs () : void {
    this.refreshCustomersSmsLogsSubject.next();
  }

  search ( query : string ) : ng.IPromise<Array<any>> {
    return this.apiService.stream('/searches', [ query, 'customers' ]);
  }

}